import { useContext, useState } from "react";

import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import Typography from "@mui/material/Typography";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

import "./accordionsdistrict.scss";

import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";

import AccordionsCommune from "../Commune/AccordionsCommune";
import DistrictAction from "../../Components/District/DistrictAction";
import { AuthContext } from "../../Context/AuthContext";
// 👉 Accordion: No border
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  border: "none",
  "&::before": {
    display: "none",
  },
}));

// 👉 AccordionSummary: No arrow icon
const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
  ({ theme }) => ({
    backgroundColor: "rgba(0, 0, 0, .03)",
    flexDirection: "row-reverse",
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
    [`& .${accordionSummaryClasses.content}`]: {
      marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles?.("dark", {
      backgroundColor: "rgba(255, 255, 255, .05)",
    }),
  })
);

// 👉 AccordionDetails: No top border
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "none",
}));

export default function AccordionsDistrict({ tableData, setRefetch }) {
  const { t } = useContext(AuthContext);

  const [expanded, setExpanded] = useState();

  const handleChange = (panelIndex) => (event, newExpanded) => {
    setExpanded(newExpanded ? panelIndex : false);
  };

  return (
    <div className="district">
      <Stack direction="column" spacing={0.7}  >
        {tableData?.map((row, index) => (
          <Accordion
            key={index}
            expanded={expanded === index}
            onChange={handleChange(index)}
            className="accordion"
          >

            <Stack direction="row" alignItems="center" sx={{ paddingRight: 1 }}>
              <AccordionSummary
                className="accordion-summary"
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  className="row"
                >
                  <Typography className="cell" width="3%">
                    {index + 1}
                  </Typography>
                  <Typography className="cell" width="19%">
                    {row?.district_municipality_code}
                  </Typography>
                  <Typography className="cell" width="19%">
                    {row?.district_municipality_name_kh}
                  </Typography>
                  <Typography className="cell" width="19%">
                    {row?.district_municipality_name_en}
                  </Typography>

                  <Typography className="cell" width="15%">
                    {row?.district_municipality_type === "district"
                      ? t("thead_district")
                      : t("thead_municipality")}
                  </Typography>

                  <Typography className="cell" width="18%">
                    {row?.isDefault && t("thead_default")}
                  </Typography>
                </Stack>
              </AccordionSummary>


              <Typography className="cell" width="10%">
                <DistrictAction editData={row} setRefetch={setRefetch} />
              </Typography>
            </Stack>

            <AccordionDetails className="accordion-details">
              <AccordionsCommune districtData={row} />
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </div>
  );
}
